import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { ShieldCheckIcon as ShieldCheck, DeviceMobileIcon as DeviceMobile } from "@phosphor-icons/react";

export default function Setup2FA() {
  const { user, setUser, logout } = useAuth();
  const navigate = useNavigate();
  const [qr, setQr] = useState(null);
  const [secret, setSecret] = useState("");
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.post("/auth/2fa/setup").then(({ data }) => { setQr(data.qr); setSecret(data.secret); }).catch((e) => toast.error(formatApiErrorDetail(e.response?.data?.detail)));
  }, []);

  const verify = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/2fa/verify", { token });
      toast.success("Autenticazione a due fattori attivata");
      const { data } = await api.get("/auth/me"); setUser(data);
      navigate(data.role === "client" ? "/portale" : "/");
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="w-full max-w-md" data-testid="setup-2fa-page">
        <div className="flex items-center gap-2 mb-2"><ShieldCheck size={24} weight="bold" className="text-primary" /><h1 className="font-heading text-2xl font-bold">Configura la 2FA</h1></div>
        <p className="text-sm text-muted-foreground mb-6">Per il tuo account è obbligatoria l'autenticazione a due fattori. Scansiona il QR con <b>Google Authenticator</b> e inserisci il codice generato.</p>
        <div className="border border-border rounded-sm p-5 bg-white text-center mb-4">
          {qr ? <img src={qr} alt="QR 2FA" className="mx-auto h-48 w-48" data-testid="setup-2fa-qr" /> : <div className="h-48 flex items-center justify-center text-muted-foreground">Generazione QR…</div>}
          {secret && <p className="text-[11px] text-muted-foreground mt-3 break-all">Chiave manuale: <code className="bg-secondary px-1 rounded-sm">{secret}</code></p>}
        </div>
        <form onSubmit={verify} className="space-y-3">
          <div>
            <Label className="text-xs uppercase tracking-wider flex items-center gap-1"><DeviceMobile size={13} /> Codice a 6 cifre</Label>
            <Input inputMode="numeric" value={token} onChange={(e) => setToken(e.target.value.replace(/\D/g, "").slice(0, 6))} placeholder="123456" className="mt-1.5 rounded-sm text-center tracking-[0.5em]" required data-testid="setup-2fa-code" />
          </div>
          <Button type="submit" disabled={loading || token.length !== 6} className="w-full rounded-sm gap-2" data-testid="setup-2fa-verify"><ShieldCheck size={16} weight="bold" /> {loading ? "Verifica…" : "Attiva e continua"}</Button>
          <button type="button" onClick={() => { logout(); navigate("/login"); }} className="w-full text-xs text-muted-foreground hover:text-foreground">Esci</button>
        </form>
      </div>
    </div>
  );
}
